import { HtmlRTEBlockProps } from '~/components/HtmlRTEBlock/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { HtmlRTEBlockCmsItem } from './models';

export const htmlRTEBlockMapper = (
  { pageBlockUI: [pageBlockUI], componentId, rte }: HtmlRTEBlockCmsItem
): HtmlRTEBlockProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI.ui),
  componentId,
  rte,
});
